import { Component, Input, input, ViewChild } from '@angular/core';
import { ZiroFieldAbstractDirective } from '../../ziro-field-abstract.directive';
import { ZiroFieldComponentConfig, ZiroFormsUpdate, ZiroFormsValidationState } from '../../ziro-forms-models';
import { ButtonSizes, ButtonStyles, ZiroButtonComponent } from '../../../button/button.component';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';
import { TimeRange } from './ziro-time-range-form.component';
import { ZiroFormsModule } from '../../ziro-forms.module';
import { TranslateModule } from '@ngx-translate/core';
import { ZiroTimeRangesFormComponent } from './ziro-time-ranges-form/ziro-time-ranges-form.component';
import { NgClass } from '@angular/common';
import { PipesModule } from '../../../shared/pipes/pipes.module';
import { isEqual } from 'lodash';

export class ZiroTimeRangesConfig extends ZiroFieldComponentConfig {}

@Component({
  selector: 'ziro-time-ranges',
  templateUrl: './ziro-time-ranges.component.html',
  imports: [ZiroFormsModule, TranslateModule, ZiroButtonComponent, ZiroTimeRangesFormComponent, NgClass, PipesModule],
  providers: [{ provide: ZiroFieldAbstractDirective, useExisting: ZiroTimeRangesComponent }],
  standalone: true,
})
export class ZiroTimeRangesComponent extends ZiroFieldAbstractDirective<
  TimeRange[],
  TimeRange[],
  ZiroTimeRangesConfig
> {
  @ViewChild(ZiroTimeRangesFormComponent) childFormComponent: ZiroTimeRangesFormComponent;

  @Input() isFormSubmitted: boolean;

  readonly canAddRanges = input<boolean>(true);
  readonly dataAutomation = input<string>('');
  readonly inlineLabel = input(true);
  readonly hideDelete = input(false);

  upstreamEntity: TimeRange[] = [];
  private _lastUpstreamValue: TimeRange[] = [];

  init(): void {
    this.config = this.config ?? ({} as any);
    this.config.validation = [
      {
        validator: () => this.childFormComponent?.getFormValidationState() ?? ZiroFormsValidationState.VALID,
        message: () => 'tkey;validators.global.error.time_range.overlapping_ranges',
      },
    ];
    super.init();
  }

  _onReceiveNewEntity = (entity: TimeRange[]): void => {
    this.upstreamEntity = entity ?? [];
    this.fieldData = entity ?? [];
    this._lastUpstreamValue = entity ?? [];
  };

  onFormUpdate(update: ZiroFormsUpdate<TimeRange[]>): void {
    this.fieldData = update.new;
    const isParentValueSyncUpdate = isEqual(update.new, this._lastUpstreamValue);
    this.updateSelf(this.fieldData, !isParentValueSyncUpdate);
  }

  hasFeedback(): boolean {
    return this.isFormSubmitted || !!this.childFormComponent?.fieldComponents?.some((f) => f.showValidation);
  }

  addSlot(): void {
    this.childFormComponent?.addItem();
  }

  protected readonly ButtonStyles = ButtonStyles;
  protected readonly ZiroIcons = ZiroIcons;
  protected readonly ButtonSizes = ButtonSizes;
}
